import React from 'react';
import { Accordion, Form } from 'react-bootstrap';
import "./About.css"

const About = () => {
    return (
        // about section......
        <div className=" pb-2 ">
            <div className="col-12 about-us-banner banner d-flex align-items-center justify-content-center w-100">
                <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="" />
            </div>

            <section className="container mt-2 pb-5">
                <h1 className="fw-bold text-center pb-5 mt-2">People Why Choose Our Coachs
                </h1>
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" className="w-100 p-5" alt=""></img>
                    </div>
                    <div className="col-lg-6">
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>We Teach You How To Coach Yourself</Accordion.Header>
                                <Accordion.Body>
                                    No matter what your coding goals are, the best place to start is by building a strong foundation.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    We Teach You How To modify your skill</Accordion.Header>
                                <Accordion.Body>
                                    Similar to a college course, this Path will teach you how to think and code like a professional.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    We Teach You How To Take Massive</Accordion.Header>
                                <Accordion.Body>
                                    You’ll learn Computer Science fundamentals, build a professional portfolio, and prepare for an entry-level role in tech with massive examples which will help you to increase your skill
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>We have best trainers who are already experienced </Accordion.Header>
                                <Accordion.Body>
                                    Kickstart your coding life as you learn all about the programming language Python, and the techniques used when writing it.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                    </div>
                </div>
            </section>
            <div className="about-us text-start">

                {/* about us content */}
                <div className="about-us-content ">
                    <div className="container py-5">
                        <h1 className="fw-bold text-secondary text-center mb-4">About Us</h1>
                        <div className="row">
                            <div className="col-lg-6">
                                <img src="https://images.unsplash.com/photo-1610702875227-f796c246cebf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=327&q=80" alt="" className="w-100 h-100" />
                            </div>
                            <div className="col-lg-6">
                                {/* <p className="text-danger fw-bold">// ABOUT US</p> */}
                                <h1 className="fw-bold text-secondary">We Care About Your eduction For Better.</h1>
                                <p>Learning to code means more than just memorizing syntax. Instead, we help you think like a real programmer. Get a helpful roadmap. Like a career advisor, we guide you through each step. You’ll learn the right thing at the right time, all in one place. Get job ready. Gain practical experience as you go by creating portfolio-worthy projects that will help you land your next job.No matter what your coding goals are, the best place to start is by building a strong foundation.Similar to a college course, this Path will teach you how to think and code like a professional.You’ll learn Computer Science fundamentals, build a professional portfolio, and prepare for an entry-level role in tech with massive examples which will help you to increase your skill </p>

                                <ul className="lh-lg">
                                    <li><i className="fas fa-check-double"></i> Best Online Professional Support </li>
                                    <li><i className="fas fa-check-double"></i> Get Instant Appointment</li>
                                    <li><i className="fas fa-check-double"></i> Take Care benefits heart health.</li>
                                    <li><i className="fas fa-check-double"></i> Highly Professional Staff</li>
                                    <li><i className="fas fa-check-double"></i> We Have 25 Years Experience</li>
                                </ul>
                                <p> You’ll learn Computer Science fundamentals, build a professional portfolio, and prepare for an entry-level role in tech with massive examples which will help you to increase your skill.Gain practical experience as you go by creating portfolio-worthy projects that will help you land your next job.No matter what your coding goals are, the best place to start is by building a strong foundation.Similar to a college course, this Path will teach you how to think and code like a professional.</p>
                                <ul className="lh-lg">
                                    <li><i className="fas fa-check-double"></i> Best Online Professional Support </li>
                                    <li><i className="fas fa-check-double"></i> Get Instant Appointment</li>
                                    <li><i className="fas fa-check-double"></i> Take Care benefits heart health.</li>
                                    <li><i className="fas fa-check-double"></i> Highly Professional Staff</li>
                                    <li><i className="fas fa-check-double"></i> We Have 25 Years Experience</li>
                                </ul>

                                <button className="btn btn-info">Discover more</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* <div>

                <h1>Book your name for our upcoming events..</h1>
                <div
                    className="container education-bg-info pb-2  rounded-3" id="subscribe">


                    <p>Get updates on sales, specials and more
                    </p>
                    <Form.Label>Student's Name</Form.Label>
                    <Form.Control type="name" placeholder="Enter your name" />
                    <br />
                    <Form.Label>Student's Email</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" />
                    <br />
                    <Form.Label>Student's Subject</Form.Label>
                    <Form.Control type="subject" placeholder="Enter your subject" />
                    <br />

                    <button className="Submit-now">SUBMIT</button>

                </div>
            </div> */}
        </div>
    );
};

export default About;